import { api, API_BASE_URL } from '../configs/apiConfig';
import axios from 'axios';

class AppointmentParametersService {
    // Employment Type Methods
    async getAllEmploymentTypes() {
        try {
            const response = await api.get('/employmenttype');
            return response.data;
        } catch (error) {
            console.error('Error fetching employment types:', error);
            throw error;
        }
    }

    async getEmploymentTypeById(id) {
        try {
            const response = await api.get(`/employmenttype/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching employment type:', error);
            throw error;
        }
    }

    async createEmploymentType(employmentType) {
        try {
            const response = await api.post('/employmenttype', {
                name: employmentType.name,
                description: employmentType.description,
                multiplier: parseFloat(employmentType.multiplier)
            });
            return response.data;
        } catch (error) {
            console.error('Error creating employment type:', error);
            throw error;
        }
    }

    async updateEmploymentType(id, employmentType) {
        try {
            const response = await api.put(`/employmenttype/${id}`, {
                name: employmentType.name,
                description: employmentType.description,
                multiplier: parseFloat(employmentType.multiplier)
            });
            return response.data;
        } catch (error) {
            console.error('Error updating employment type:', error);
            throw error;
        }
    }

    async deleteEmploymentType(id) {
        try {
            await api.delete(`/employmenttype/${id}`);
        } catch (error) {
            console.error('Error deleting employment type:', error);
            throw error;
        }
    }

    // Education Level Methods
    async getAllEducationLevels() {
        try {
            const response = await api.get('/EducationLevel');
            return response.data;
        } catch (error) {
            console.error('Error fetching education levels:', error);
            throw error;
        }
    }

    async getEducationLevelById(id) {
        try {
            const response = await api.get(`/EducationLevel/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching education level:', error);
            throw error;
        }
    }

    async createEducationLevel(educationLevel) {
        try {
            const response = await api.post('/EducationLevel', educationLevel);
            return response.data;
        } catch (error) {
            console.error('Error creating education level:', error);
            throw error;
        }
    }

    async updateEducationLevel(id, educationLevel) {
        try {
            const response = await api.put(`/EducationLevel/${id}`, educationLevel);
            return response.data;
        } catch (error) {
            console.error('Error updating education level:', error);
            throw error;
        }
    }

    async deleteEducationLevel(id) {
        try {
            await api.delete(`/EducationLevel/${id}`);
        } catch (error) {
            console.error('Error deleting education level:', error);
            throw error;
        }
    }

    // Experience Level Methods
    async getAllExperienceLevels() {
        try {
            const response = await api.get('/ExperienceLevel');
            return response.data;
        } catch (error) {
            console.error('Error fetching experience levels:', error);
            throw error;
        }
    }

    async getExperienceLevelById(id) {
        try {
            const response = await api.get(`/ExperienceLevel/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching experience level:', error);
            throw error;
        }
    }

    async createExperienceLevel(experienceLevel) {
        try {
            const response = await api.post('/ExperienceLevel', experienceLevel);
            return response.data;
        } catch (error) {
            console.error('Error creating experience level:', error);
            throw error;
        }
    }

    async updateExperienceLevel(id, experienceLevel) {
        try {
            const response = await api.put(`/ExperienceLevel/${id}`, experienceLevel);
            return response.data;
        } catch (error) {
            console.error('Error updating experience level:', error);
            throw error;
        }
    }

    async deleteExperienceLevel(id) {
        try {
            await api.delete(`/ExperienceLevel/${id}`);
        } catch (error) {
            console.error('Error deleting experience level:', error);
            throw error;
        }
    }

    // Organizational Level Methods
    async getAllOrganizationalLevels() {
        try {
            const response = await api.get('/OrganizationalLevel');
            return response.data;
        } catch (error) {
            console.error('Error fetching organizational levels:', error);
            throw error;
        }
    }

    async getOrganizationalLevelById(id) {
        try {
            const response = await api.get(`/OrganizationalLevel/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching organizational level:', error);
            throw error;
        }
    }

    async createOrganizationalLevel(organizationalLevel) {
        try {
            const response = await api.post('/OrganizationalLevel', organizationalLevel);
            return response.data;
        } catch (error) {
            console.error('Error creating organizational level:', error);
            throw error;
        }
    }

    async updateOrganizationalLevel(id, organizationalLevel) {
        try {
            const response = await api.put(`/OrganizationalLevel/${id}`, organizationalLevel);
            return response.data;
        } catch (error) {
            console.error('Error updating organizational level:', error);
            throw error;
        }
    }

    async deleteOrganizationalLevel(id) {
        try {
            await api.delete(`/OrganizationalLevel/${id}`);
        } catch (error) {
            console.error('Error deleting organizational level:', error);
            throw error;
        }
    }

    // Organizational Unit Type Methods
    async getAllOrganizationalUnitTypes() {
        try {
            const response = await api.get('/organizationalunittype');
            return response.data;
        } catch (error) {
            console.error('Error fetching organizational unit types:', error);
            throw error;
        }
    }

    async updateOrganizationalUnitTypeMultiplier(id, typeData) {
        try {
            const response = await api.put(`/organizationalunittype/${id}`, typeData);
            return response.data;
        } catch (error) {
            console.error('Error updating organizational unit type multiplier:', error);
            throw error;
        }
    }

    // Helper method to format error messages
    formatErrorMessage(error) {
        if (error.response?.data?.message) {
            return error.response.data.message;
        }
        return 'An unexpected error occurred. Please try again.';
    }
}

export default new AppointmentParametersService(); 